import { useMutation } from '@tanstack/react-query';
import { format } from 'date-fns';

import { endpoints } from 'global/endpoints';
import { downloadFile } from 'utils/helpers';
import http from 'utils/http';

interface IDownloadUsersCSVPostData {
  active: string;
}

const downloadUsersCSV = (postData: IDownloadUsersCSVPostData) => {
  const newEndpoints = endpoints.reports.downloadUsersCSV;
  return http()
    .post(newEndpoints, postData, { responseType: 'blob' })
    .then(res => new Blob([res]))
    .then(blob => {
      downloadFile(blob, `users-${format(new Date(), 'yMdHms')}.csv`);
    });
};

export function useDownloadUsersCSV() {
  return useMutation({ mutationFn: downloadUsersCSV });
}
